import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../wayfinder'
import profile937a89 from './profile'
import appearance from './appearance'
import plan from './plan'
/**
* @see \App\Http\Controllers\Creator\SetupController::profile
* @see app/Http/Controllers/Creator/SetupController.php:29
* @route '/app/creator/setup/profile'
*/
export const profile = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: profile.url(options),
    method: 'get',
})

profile.definition = {
    methods: ["get","head"],
    url: '/app/creator/setup/profile',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Creator\SetupController::profile
* @see app/Http/Controllers/Creator/SetupController.php:29
* @route '/app/creator/setup/profile'
*/
profile.url = (options?: RouteQueryOptions) => {
    return profile.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Creator\SetupController::profile
* @see app/Http/Controllers/Creator/SetupController.php:29
* @route '/app/creator/setup/profile'
*/
profile.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: profile.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Creator\SetupController::profile
* @see app/Http/Controllers/Creator/SetupController.php:29
* @route '/app/creator/setup/profile'
*/
profile.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: profile.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Creator\SetupController::profile
* @see app/Http/Controllers/Creator/SetupController.php:29
* @route '/app/creator/setup/profile'
*/
const profileForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: profile.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Creator\SetupController::profile
* @see app/Http/Controllers/Creator/SetupController.php:29
* @route '/app/creator/setup/profile'
*/
profileForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: profile.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Creator\SetupController::profile
* @see app/Http/Controllers/Creator/SetupController.php:29
* @route '/app/creator/setup/profile'
*/
profileForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: profile.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

profile.form = profileForm

/**
* @see \App\Http\Controllers\Creator\SetupController::step
* @see app/Http/Controllers/Creator/SetupController.php:123
* @route '/app/creator/setup/{step}'
*/
export const step = (args: { step: string | number } | [step: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: step.url(args, options),
    method: 'get',
})

step.definition = {
    methods: ["get","head"],
    url: '/app/creator/setup/{step}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Creator\SetupController::step
* @see app/Http/Controllers/Creator/SetupController.php:123
* @route '/app/creator/setup/{step}'
*/
step.url = (args: { step: string | number } | [step: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { step: args }
    }

    if (Array.isArray(args)) {
        args = {
            step: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        step: args.step,
    }

    return step.definition.url
            .replace('{step}', parsedArgs.step.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Creator\SetupController::step
* @see app/Http/Controllers/Creator/SetupController.php:123
* @route '/app/creator/setup/{step}'
*/
step.get = (args: { step: string | number } | [step: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: step.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Creator\SetupController::step
* @see app/Http/Controllers/Creator/SetupController.php:123
* @route '/app/creator/setup/{step}'
*/
step.head = (args: { step: string | number } | [step: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: step.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Creator\SetupController::step
* @see app/Http/Controllers/Creator/SetupController.php:123
* @route '/app/creator/setup/{step}'
*/
const stepForm = (args: { step: string | number } | [step: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: step.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Creator\SetupController::step
* @see app/Http/Controllers/Creator/SetupController.php:123
* @route '/app/creator/setup/{step}'
*/
stepForm.get = (args: { step: string | number } | [step: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: step.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Creator\SetupController::step
* @see app/Http/Controllers/Creator/SetupController.php:123
* @route '/app/creator/setup/{step}'
*/
stepForm.head = (args: { step: string | number } | [step: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: step.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

step.form = stepForm

/**
* @see \App\Http\Controllers\Creator\SetupController::skipPayment
* @see app/Http/Controllers/Creator/SetupController.php:209
* @route '/app/creator/setup/skip-payment'
*/
export const skipPayment = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: skipPayment.url(options),
    method: 'post',
})

skipPayment.definition = {
    methods: ["post"],
    url: '/app/creator/setup/skip-payment',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Creator\SetupController::skipPayment
* @see app/Http/Controllers/Creator/SetupController.php:209
* @route '/app/creator/setup/skip-payment'
*/
skipPayment.url = (options?: RouteQueryOptions) => {
    return skipPayment.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Creator\SetupController::skipPayment
* @see app/Http/Controllers/Creator/SetupController.php:209
* @route '/app/creator/setup/skip-payment'
*/
skipPayment.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: skipPayment.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Creator\SetupController::skipPayment
* @see app/Http/Controllers/Creator/SetupController.php:209
* @route '/app/creator/setup/skip-payment'
*/
const skipPaymentForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: skipPayment.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Creator\SetupController::skipPayment
* @see app/Http/Controllers/Creator/SetupController.php:209
* @route '/app/creator/setup/skip-payment'
*/
skipPaymentForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: skipPayment.url(options),
    method: 'post',
})

skipPayment.form = skipPaymentForm

/**
* @see \App\Http\Controllers\Creator\SetupController::complete
* @see app/Http/Controllers/Creator/SetupController.php:349
* @route '/app/creator/setup/complete'
*/
export const complete = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: complete.url(options),
    method: 'post',
})

complete.definition = {
    methods: ["post"],
    url: '/app/creator/setup/complete',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Creator\SetupController::complete
* @see app/Http/Controllers/Creator/SetupController.php:349
* @route '/app/creator/setup/complete'
*/
complete.url = (options?: RouteQueryOptions) => {
    return complete.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Creator\SetupController::complete
* @see app/Http/Controllers/Creator/SetupController.php:349
* @route '/app/creator/setup/complete'
*/
complete.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: complete.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Creator\SetupController::complete
* @see app/Http/Controllers/Creator/SetupController.php:349
* @route '/app/creator/setup/complete'
*/
const completeForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: complete.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Creator\SetupController::complete
* @see app/Http/Controllers/Creator/SetupController.php:349
* @route '/app/creator/setup/complete'
*/
completeForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: complete.url(options),
    method: 'post',
})

complete.form = completeForm

/**
* @see \App\Http\Controllers\Creator\SetupController::checkSlug
* @see app/Http/Controllers/Creator/SetupController.php:321
* @route '/app/creator/setup/check-slug'
*/
export const checkSlug = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: checkSlug.url(options),
    method: 'post',
})

checkSlug.definition = {
    methods: ["post"],
    url: '/app/creator/setup/check-slug',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Creator\SetupController::checkSlug
* @see app/Http/Controllers/Creator/SetupController.php:321
* @route '/app/creator/setup/check-slug'
*/
checkSlug.url = (options?: RouteQueryOptions) => {
    return checkSlug.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Creator\SetupController::checkSlug
* @see app/Http/Controllers/Creator/SetupController.php:321
* @route '/app/creator/setup/check-slug'
*/
checkSlug.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: checkSlug.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Creator\SetupController::checkSlug
* @see app/Http/Controllers/Creator/SetupController.php:321
* @route '/app/creator/setup/check-slug'
*/
const checkSlugForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: checkSlug.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Creator\SetupController::checkSlug
* @see app/Http/Controllers/Creator/SetupController.php:321
* @route '/app/creator/setup/check-slug'
*/
checkSlugForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: checkSlug.url(options),
    method: 'post',
})

checkSlug.form = checkSlugForm

const setup = {
    profile: Object.assign(profile, profile937a89),
    step: Object.assign(step, step),
    appearance: Object.assign(appearance, appearance),
    plan: Object.assign(plan, plan),
    skipPayment: Object.assign(skipPayment, skipPayment),
    complete: Object.assign(complete, complete),
    checkSlug: Object.assign(checkSlug, checkSlug),
}

export default setup